import request from "@/utils/request";
import { IEviBusiness } from "../model/evibusiness";

// 实体
export const defaultEviBusinessData: IEviBusiness = {
  id: "",
  appId: "",
  businessName: "",
  businessType: 0,
  createTime: 0,
  creatorId: "",
  updateTime: 0,
  updateId: "",
  isActive: 0,
  businessRemark: "",
  businessNo: "",
  sort: 0
};

export const getEviBusiness = (id: any) => {
  request({
    url: "/EviBusiness/Get",
    method: "post",
    params: { id: id }
  });
};

export const addEviBusiness = (data: any) =>
  request({
    url: "/EviBusiness/Add",
    method: "post",
    data
  });

export const updateEviBusiness = (data: any) =>
  request({
    url: "/EviBusiness/Update",
    method: "post",
    data
  });

export const deleteEviBusiness = (id: string) =>
  request({
    url: "/EviBusiness/Delete",
    method: "post",
    params: { id: id }
  });

export const getEviBusinessPageList = (data: any) =>
  request({
    url: "/EviBusiness/GetPageListAsync",
    method: "post",
    data
  });

export const getEviBusinessArr = () =>
  request({
    url: "/EviBusiness/GetEviBusinessArr",
    method: "post"
  });

export const getBusinessNo = () =>
  request({
    url: "/EviBusiness/GetBusinessNo",
    method: "post"
  });

export const getEviBusinessArrByAppId = (appId: string) =>
  request({
    url: "/EviBusiness/GetEviBusinessArrByAppId",
    method: "post",
    params: { appid: appId }
  });
